import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            海量影视分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            涵盖电影、电视剧、综艺、动漫、纪录片等全品类资源
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 rounded-2xl p-6 text-center hover:bg-primary-50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl text-primary-600 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}